import { IonList, IonItem, IonLabel, IonIcon, IonButton } from '@ionic/react'
import { checkmarkCircle } from 'ionicons/icons'
import { formatPhoneNumber } from 'react-phone-number-input'

import { useBoolean } from '../../../hooks/use-boolean'
import PhoneEditForm from '../../../components/client/PhoneEditForm'
import { InfoCard } from './info-card'

import type { PhoneNumber } from '../../../hooks/clients/queries'

type Props = {
  clientId: string
  isEditDisabled: boolean
  isUnsubscribed: boolean
  phoneNumbers: Array<PhoneNumber>
  updateEditStatus: (status: boolean) => void
}

function PhoneCard({
  clientId,
  isEditDisabled,
  phoneNumbers,
  updateEditStatus,
  isUnsubscribed,
}: Props) {
  const [isEditing, { off: hideEdit, on: showEdit }] = useBoolean()

  return (
    <InfoCard>
      {isEditing ? (
        <PhoneEditForm
          clientId={clientId}
          phoneNumbers={phoneNumbers}
          onCancel={() => {
            hideEdit()
            updateEditStatus(true)
          }}
          onSave={() => {
            hideEdit()
            updateEditStatus(true)
          }}
        />
      ) : (
        <section>
          {phoneNumbers.length === 0 ? (
            <div className="text-ion-color-primary">
              This client currently has no phone numbers saved.
            </div>
          ) : (
            <IonList>
              {phoneNumbers.map((phoneNumber, index) => (
                <IonItem
                  color="secondary"
                  key={phoneNumber.objectId}
                  lines={index === phoneNumbers.length - 1 ? 'none' : 'inset'}
                >
                  <IonLabel>
                    <div>
                      <div className="text-ion-color-primary font-semibold">
                        {phoneNumber.posName ?? 'No Label'}
                      </div>
                      <span>
                        {phoneNumber.e164
                          ? formatPhoneNumber(phoneNumber.e164.toString())
                          : phoneNumber.phoneNumber}
                      </span>
                      <span>
                        {phoneNumber.verified
                          ? ` (Verified${
                              phoneNumber.type ? `: ${phoneNumber.type}` : ''
                            })`
                          : null}
                      </span>
                    </div>
                  </IonLabel>
                  {phoneNumber.default && (
                    <IonIcon
                      color={isUnsubscribed ? 'tertiary' : 'primary'}
                      slot="end"
                      icon={checkmarkCircle}
                    />
                  )}
                </IonItem>
              ))}
            </IonList>
          )}
          <div className="flex justify-end">
            <IonButton
              size="small"
              fill="outline"
              disabled={isEditDisabled}
              onClick={() => {
                showEdit()
                updateEditStatus(false)
              }}
            >
              Edit
            </IonButton>
          </div>
        </section>
      )}
    </InfoCard>
  )
}

export { PhoneCard }
